export const TABS_TOP = 58
export const TABS_HEIGHT = 48

export const FOOTER_BOTTOM_OFFSET = 84
